import Vue from 'vue'
import store from '../store'

import {
  // timeTypes,
  // dateTypes,
  daysList,
  zoneTypes
} from './scheduleHelpers'

const zoneTypesMap = new Map(zoneTypes)

function install() {
  Vue.filter('agencyName', value => {
    if (value === null) return 'NA'
    const agencie = store.getters.agenciesMap.get(value)
    return agencie.name
  })

  Vue.filter('filterFullDate', value => {
    if (value === undefined) return
    if (value === null || value === 'Estático' || value === 'NA') return value
    const fullDate = value.split(' ')
    const _date = fullDate[0].split('-').reverse().join('/')
    return `${_date} | ${fullDate[1]}`
  })

  Vue.filter('filterDate', value => {
    if (value === null) return value
    let _date = value.split(' ')
    _date = _date[0].split('-').reverse().join('/')
    return _date
  })

  Vue.filter('filterTime', value => {
    if (value === null) return value
    const _time = value.split(' ')
    return _time[1]
  })

  Vue.filter('convertDaysOfWeek', value => {
    const {text} = daysList.find(dayObject => {
      return dayObject.value === value
    })
    return text
  })

  Vue.filter('convertZoneType', value => {
    return zoneTypesMap.get(value)
  })

  Vue.filter('secondsToHHMMSS', value => {
    const SECONDS_PER_DAY = 86400
    const HOURS_PER_DAY = 24

    const days = Math.floor(value / SECONDS_PER_DAY)
    const remainderSeconds = value % SECONDS_PER_DAY
    const hms = new Date(remainderSeconds * 1000).toISOString().substring(11, 19)
    return hms.replace(/^(\d+)/, h => `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, '0'))
  })
}

export default install



// WEBPACK FOOTER //
// ./src/utils/GlobalFilters.js